import {
  GET_NOTIFICATIONS_FAILED,
  GET_NOTIFICATIONS_SUCCESS,
  MARK_GRADEBOOK_NOTIFICATION_SUCCESS,
  UPDATE_NOTIFICATION_SUCCESS,
} from "../constants";

export const initialState = {
  notificationsList: undefined,
  notificationsListError: undefined,
};

export const NotificationReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        notificationsList: action.payload,
        notificationsListError: undefined,
      };
    }

    case GET_NOTIFICATIONS_FAILED: {
      return {
        ...state,
        notificationsList: undefined,
        notificationsListError: action.payload,
      };
    }

    case UPDATE_NOTIFICATION_SUCCESS: {
      const updatedData = state.notificationsList.data.filter(
        (notification) => notification._id !== action.payload
      );

      return {
        ...state,
        notificationsList: {
          ...state.notificationsList,
          data: updatedData,
          count: updatedData.length,
        },
      };
    }
 
    case MARK_GRADEBOOK_NOTIFICATION_SUCCESS: {
      const updatedData = state.notificationsList.data.filter(
        (notification) => notification._id !== action.payload
      );

      return {
        ...state,
        notificationsList: {
          ...state.notificationsList,
          data: updatedData,
          count: updatedData.length,
        },
    };
  }

    default:
      return state;
  }
};
